module.exports = __webpack_public_path__ + "img/49.bced0d11.png";